import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(".submetrics-popover").popover({
      content: function() {
        var contentId = "content-id-" + $(this).data("coin-id") + "-" + $(this).data("submetric");

        // If element already exist somewhere load it from there
        var cacheContent = $("#submetrics-popover-container-caches").find("#cache-" + contentId);
        if (cacheContent.length > 0) {
          return '<div id="' + contentId + '">' + cacheContent.html() + "</div>";
        } else {
          fetch($(this).data("url"), { credentials: "same-origin" })
            .then(response => response.text())
            .then(function(d) {
              var content = $("#" + contentId).html(d);
              var cacheContent = $("<div id='cache-" + contentId + "' ></div>").append(d);
              $("#submetrics-popover-container-caches").append(cacheContent);
            });
          return '<div id="' + contentId + '">Loading...</div>';
        }
      },

      placement: "bottom",
      html: true,
      trigger: "hover",
      delay: 450,
      template: `<div class="popover submetrics-popover-container" role="tooltip">
        <div class="arrow"></div>
        <h3 class="popover-header"></h3>
        <div class="popover-body"></div>
      </div>`
    });

    $(".popover-dismiss").popover({
      trigger: "focus"
    });
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/coins_controller.js